import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=018be2b6&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style1 from "./Editor.vue?vue&type=style&index=1&id=018be2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018be2b6",
  null
  
)

export default component.exports